// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import color from 'michelangelo/dist/Components/styles/color'
import Text from './Text'
import Caption from './Caption'

type TitleHeaderProps = {
    title: string,
    useParallax: boolean
}
const TitleTextContainer: ReactComponentStyled<{}> = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 100%;
`
TitleTextContainer.displayName = 'TitleTextContainer'
const HeaderContainer: ReactComponentStyled<{}> = styled.div`
  height: 300px;
  width: 100%;
  background: ${color.moonlightGradient};
  text-align: center;
  line-height: 300px;

  ${(props) => {
    if (props.useParallax) {
      return `
        @media only screen and (min-width : 320px) and (max-width : 823px){
          height: 50vh;
          line-height: 50vh;
        }`
    } else {
      return `
        @media only screen and (max-height: 400px) {
          height: 200px;
          line-height: 200px;
        }
      `
    }
  }}
`
HeaderContainer.displayName = 'HeaderContainer'

class TitleHeader extends Component<TitleHeaderProps, {}> {
  render () {
    const { title, useParallax } = this.props
    return (
      <HeaderContainer useParallax={useParallax}>
        <TitleTextContainer>
          <Caption usePadding={false}>
            <Text text={title} size='1' align='left' fontColor='white' />
          </Caption>
        </TitleTextContainer>
      </HeaderContainer>
    )
  }
}

export default TitleHeader
